module.exports = __webpack_public_path__ + "img/yt-wmemo_mim.1b753a0b.png";